import React from 'react'

function StartYourJourney() {
  return (
    <div>StartYourJourney</div>
  )
}

export default StartYourJourney